import React, { useState } from 'react';
import SEO from '../SEO/SEO';
import Header from '../Header/Header';
import { trackFormSubmission } from '../../utils/analytics';
import Footer from '../Footer/Footer';
import { Mail, Phone } from 'lucide-react';
import '../Styles/reset.css';
import '../Styles/utils.css';
import '../Styles/layout.css';
import emailjs from 'emailjs-com';

function ContactPage() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs.init("lCuy7ViI1Dca5Aj-S"); // Replace with your EmailJS Public Key

        emailjs.send("service_33usdhk", "template_3vsatgn", {
            from_name: formData.name,
            reply_to: formData.email,
            subject: formData.subject,
            message: formData.message
        })
            .then((response) => {
                console.log("Email sent successfully:", response);
                trackFormSubmission('Contact Form', true);
                setIsSubmitted(true);
                setFormData({
                    name: '',
                    email: '',
                    subject: '',
                    message: ''
                });
            })
            .catch((error) => {
                console.error("Failed to send email:", error);
                trackFormSubmission('Contact Form', false);
                alert("There was an issue sending your message. Please try again later.");
            });
    };

    return (
        <div>
            <SEO
                title="Contact Us - SmartLifeChoice"
                description="Get in touch with SmartLifeChoice. Have questions, feedback, or collaboration ideas? We'd love to hear from you. Contact us via our form, email, or phone."
                url="/contact"
                keywords="contact smartlifechoice, health blog contact, fitness advice inquiry"
            />
            <Header />

            <main className="main">
                <div className="container">
                    <h1 className="section-title">Contact Us</h1>
                    <p className="mb-4">
                        Have questions, feedback, or want to work with us? We'd love to hear from you!
                        Fill out the form below or use our contact information to get in touch.
                    </p>

                    <div className="contact-grid">
                        <div className="contact-form">
                            {isSubmitted ? (
                                <div className="p-4 rounded-lg" style={{ backgroundColor: 'var(--color-success)', color: 'white' }}>
                                    <h3>Thank you for your message!</h3>
                                    <p>We've received your inquiry and will get back to you as soon as possible.</p>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="name" className="form-label">Your Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                            className="form-input"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="email" className="form-label">Your Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            className="form-input"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="subject" className="form-label">Subject</label>
                                        <input
                                            type="text"
                                            id="subject"
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            required
                                            className="form-input"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="message" className="form-label">Your Message</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                            className="form-textarea"
                                        ></textarea>
                                    </div>

                                    <button type="submit" className="btn btn-primary">Send Message</button>
                                </form>
                            )}
                        </div>

                        <div className="contact-info">
                            <h3>Get In Touch</h3>
                            <p className="mb-3">
                                Feel free to reach out to us using any of the contact methods below.
                                We aim to respond to all inquiries within 24-48 hours.
                            </p>

                            <div className="contact-item">
                                <div className="contact-icon">
                                    <Mail />
                                </div>
                                <div>
                                    <h4>Email</h4>
                                    <p>smartlifechoiceuk@gmail.com</p>
                                </div>
                            </div>

                            <div className="contact-item">
                                <div className="contact-icon">
                                    <Phone />
                                </div>
                                <div>
                                    <h4>Phone</h4>
                                    <p>+447462365503</p>
                                </div>
                            </div>

                            {/* <div className="contact-item">
                                <div className="contact-icon">
                                    <MapPin />
                                </div>
                                <div>
                                    <h4>Location</h4>
                                    <p>123 Fitness Street<br />Wellness City, WC 12345</p>
                                </div>
                            </div> */}

                            {/* <h3 className="mt-4">Working Hours</h3>
                            <p>Monday - Friday: 9AM - 6PM<br />Saturday: 10AM - 4PM<br />Sunday: Closed</p> */}
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default ContactPage;
